import {
    CountModuleName,
    StatusModuleName,
    SwedishSakModuleName,
} from './../config';

import { baseApi } from '@klp/core/api';
import { SakModuleName } from '../config';
import { getConfig } from '@klpkonsern/appconfig';

export type ISakStatistics = {
    statusName: string;
    statusCode: string;
    statusId: string;
    statusCount: number;
};

const BaseUrl = getConfig('WEBAPP_API_URL');

export const sakApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getSakStatistics: build.query<
            Array<ISakStatistics>,
            { byggnummer?: string; email?: string }
        >({
            query: ({ byggnummer, email }) => ({
                url: `${BaseUrl}/kundeportal/${SakModuleName}/${StatusModuleName}/${CountModuleName}`,
                params: { byggnummer, email },
            }),
        }),
        getSwedishSakStatistics: build.query<
            Array<ISakStatistics>,
            { byggnummer?: string; email?: string }
        >({
            query: ({ byggnummer, email }) => ({
                url: `${BaseUrl}/kundeportal/${SwedishSakModuleName}/${StatusModuleName}/${CountModuleName}`,
                params: { byggnummer, email },
            }),
        }),
    }),
});

export const { useGetSakStatisticsQuery, useGetSwedishSakStatisticsQuery } =
    sakApi;
